const StatisticsRenderer = require('./StatisticsRenderer');
const RenderUtil = require('../RenderUtil');
const LayerUtil = require('../../utils/LayerUtil');
const CommonUtil = require('../../utils/CommonUtil');
const g2 = require('../../g2');

/**
 * 简单图表渲染
 * @ignore
 * @param {Object} options - 构造参数；
 * @param {G.Map} options.map - 地图对象
 * @param {String} options.id
 * @param {String} options.name
 * @param {String} options.idField
 * @param {Object} options.featureBuilder
 * @param {String} options.geometryType
 * @param {Object} options.renderOption
 * @param {Object} options.eventDispatcher 
 *
 * @example
 * //使用示例代码
 * //todo
 */
let renderer = StatisticsRenderer.extend({
    options: {},
    initialize(options) {
        StatisticsRenderer.prototype.initialize.call(this, options);
        //
        this.gvInstance = null;
        this.gvOptions = null;
        this.initListeners();
    },

    /**
     */
    destroy() {
        this.clear();
        this.destroyGvInstance();
        this.featureCol = null;
        this.gvOptions = null;
        StatisticsRenderer.prototype.destroy.call(this);
    },

    /**
     */
    getGvInstance(source) {},

    /**
     * 销毁
     * 
     */
    destroyGvInstance() {
        if (this.gvInstance) {
            this.gvInstance.unbind(this.options.map);
            this.removeListeners();
            this.gvInstance = null;
        }
    },

    /**
     * 
     */
    getGvOptions() {
        this.gvOptions = this.options.renderOption.style || this.options.renderOption.chart;
        return this.gvOptions;
    },


    //渲染
    render() {
        let featureSet = this.featureSet;
        let featureCol = RenderUtil.featureSet2GeoJson(featureSet);
        let source = new gv.source.GeoJsonSource(featureCol);
        let gvInstance = this.getGvInstance();
        gvInstance.setDataSource(source);
        gvInstance.render();
    },

    /**
     *
     */
    clear() {
        this.layer.clear();
        this.featureSet.features = [];
        //gv error with empty featurecollection
        // this.render();
    },

    setVisible(visible) {
        let instance = this.getGvInstance();
        if (instance) {
            instance.setVisible(!!visible);
            return true;
        }
        return false;
    },

    getVisible() {
        let instance = this.getGvInstance();
        if (instance) {
            return instance.getVisible();
        }
        return undefined;
    },

    addListeners() {
        if (this.gvInstance) {
            this.gvInstance.on('click', this.onClick);
            this.gvInstance.on('mouseover', this.onMouseOver);
            this.gvInstance.on('mouseout', this.onMouseOut);
        }
    },

    removeListeners() {
        if (this.gvInstance) {
            this.gvInstance.un('click', this.onClick);
            this.gvInstance.un('mouseover', this.onMouseOver);
            this.gvInstance.un('mouseout', this.onMouseOut);
        }
    },
});

module.exports = renderer;